import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "build_details_container"
};
const _hoisted_2 = {
  class: "build_scene border",
  id: "build_scene",
  ref: "build_scene_ref",
  style: {
    "max-width": "1080px"
  }
};
const _hoisted_3 = {
  class: "build_image row"
};
const _hoisted_4 = {
  id: "build_alert",
  class: "col-12 text-center build_alert",
  style: {
    "display": "none"
  }
};
const _hoisted_5 = {
  class: "alert alert-primary",
  role: "alert"
};
const _hoisted_6 = {
  id: "minimapContainer",
  class: "col-10 d-flex align-items-center justify-content-center minimap_container",
  ref: "minmap_container"
};
const _hoisted_7 = {
  id: "build_part_ani",
  class: "col-12 d-flex align-items-center justify-content-center build_part",
  ref: "build_part"
};
const _hoisted_8 = {
  class: "row d-flex align-items-center justify-content-center build_button",
  ref: "build_button"
};
const _hoisted_9 = {
  class: "col-6 text-center build_button_next_prev"
};
const _hoisted_10 = {
  class: "col-6 text-center build_button_next_prev",
  "mc-ace": "~"
};
const _hoisted_11 = {
  type: "button",
  class: "btn btn-primary button_single",
  id: "nextBut"
};
const _hoisted_12 = {
  key: 0,
  class: "loading-overlay"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft");
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_icon, {
    class: "back-icon",
    onClick: $options.goBack
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowLeft)]),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('messages.quicklocate_tip')), 1)]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "col-1"
  }, null, -1)), _createElementVNode("div", _hoisted_6, null, 512), _createElementVNode("div", _hoisted_7, _cache[0] || (_cache[0] = [_createElementVNode("div", {
    class: "part_container",
    id: "part_container"
  }, null, -1)]), 512)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary button_single",
    id: "prevBut",
    ref: "button_single"
  }, _toDisplayString(_ctx.$t('messages.build_detail_back')), 513)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.$t('messages.build_detail_next')), 1)])], 512)], 512), $data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("p", null, _toDisplayString($data.loadingText), 1)])) : _createCommentVNode("", true)]);
}